/* SoulfulWishes: progressive enhancements only. All article content renders in Liquid. */
(() => {
  'use strict';

  const copyText = async (text) => {
    if (!navigator.clipboard || !window.isSecureContext) return false;
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      return false;
    }
  };

  const buildToc = (root) => {
    const body = root.querySelector('[data-sw-article-body]');
    if (!body) return;
    const headings = Array.from(body.querySelectorAll('h2')).filter(h => h.textContent.trim());
    if (headings.length < 2) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `sw-heading-${root.id}-${index + 1}`;
    });

    root.querySelectorAll('[data-sw-toc]').forEach(nav => {
      const list = nav.querySelector('[data-sw-toc-list]');
      if (!list) return;
      const fragment = document.createDocumentFragment();
      headings.forEach(heading => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        fragment.appendChild(item);
      });
      list.appendChild(fragment);
      nav.hidden = false;
    });
  };

  const attachCopyButtons = (root) => {
    const body = root.querySelector('[data-sw-article-body]');
    if (!body) return;
    body.querySelectorAll('blockquote').forEach(quote => {
      // Leave complex nested quotes alone. The original text remains visible.
      if (quote.querySelector('blockquote')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sw-post__quote-copy';
      button.textContent = 'Copy';
      button.setAttribute('aria-label', 'Copy this quote or message');
      button.addEventListener('click', async () => {
        const duplicate = quote.cloneNode(true);
        duplicate.querySelectorAll('.sw-post__quote-copy').forEach(node => node.remove());
        const text = duplicate.textContent.trim().replace(/^\d{1,3}\.\s*/, '');
        if (!text) return;
        const success = await copyText(text);
        button.textContent = success ? 'Copied!' : 'Copy unavailable';
      });
      quote.appendChild(button);
    });
  };

  const attachShare = (root) => {
    root.querySelectorAll('[data-sw-copy-link]').forEach(button => {
      button.addEventListener('click', async () => {
        const success = await copyText(button.dataset.url || window.location.href);
        const status = root.querySelector('[data-sw-share-status]');
        button.textContent = success ? 'Link copied!' : 'Copy unavailable';
        if (status) status.textContent = success ? 'Article link copied to clipboard.' : 'Clipboard is unavailable. Please copy the URL from your browser.';
      });
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-sw-post]').forEach(root => {
      if (root.dataset.swEnhanced === 'true') return;
      root.dataset.swEnhanced = 'true';
      buildToc(root);
      attachCopyButtons(root);
      attachShare(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
